import config from 'appConfig';

export const getBaseDomain = () => config.baseDomain || window.location.host;

export const getAuthDomain = () => config.authDomain || window.location.host;



// WEBPACK FOOTER //
// ./src/services/domain.ts